import type { AppProps } from "next/app";
import { useRouter } from "next/router";
import type { PropsWithChildren } from "react";
import type { AvailableRoutes } from "resources/availableRoutes";

export function LayoutBypass({
  children,
  Component,
  pageProps,
}: PropsWithChildren<{
  Component: AppProps["Component"];
  pageProps: AppProps["pageProps"];
}>) {
  const { pathname } = useRouter();
  const bypassPathnames: AvailableRoutes[] = [
    "/signin-oidc",
    "/logout",
    "/impersonation-callback",
  ];

  if (bypassPathnames.includes(pathname as AvailableRoutes)) {
    return <Component {...pageProps} />;
  }

  return <>{children}</>;
}
